// src/components/gestionEvento/SiembraManager.js
import React, { useState, useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SessionSiembra from './siembraManager/SessionSiembra';
import { useSiembraConfig } from './siembraManager/useSiembraConfig';
import MassEditModal from './siembraManager/MassEditModal';

export default function SiembraManager({ competencia }) {  // Recibimos competencia por props
  // Extraemos las sesiones directamente de la competencia
  const sessions = useMemo(() => competencia?.sessions || [], [competencia]);

  const allSchedules = useMemo(
    () => sessions.flatMap((s) => s.schedules || []),
    [sessions]
  );

  const { pruebasConfig, handleConfigChange } = useSiembraConfig(allSchedules);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [massEditOpen, setMassEditOpen] = useState(false);

  if (!competencia) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        Competencia no disponible
      </Typography>
    );
  }

  // Resto del componente permanece igual...
  const onSelectRow = (id, checked) => {
    setSelectedRows((prev) => {
      const newSet = new Set(prev);
      if (checked) newSet.add(id);
      else newSet.delete(id);
      return newSet;
    });
  };

  const handleOpenMassEdit = () => setMassEditOpen(true);
  const handleCloseMassEdit = () => setMassEditOpen(false);

  const handleSaveMassive = (massEditValues) => {
    selectedRows.forEach((rowId) => {
      Object.entries(massEditValues).forEach(([field, value]) => {
        if (value !== 'NO_CHANGE') {
          handleConfigChange(rowId, field, value);
        }
      });
    });
    setMassEditOpen(false);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Configuración de Siembra (session.schedules)
      </Typography>

      {selectedRows.size > 0 && (
        <Button variant="outlined" onClick={handleOpenMassEdit} sx={{ mb: 2 }}>
          Editar {selectedRows.size} seleccionados
        </Button>
      )}

      {sessions.map((session) => (
        <SessionSiembra
          key={session.id}
          session={session}
          pruebasConfig={pruebasConfig}
          onConfigChange={handleConfigChange}
          selectedRows={selectedRows}
          onSelectRow={onSelectRow}
        />
      ))}

      <MassEditModal
        open={massEditOpen}
        onClose={handleCloseMassEdit}
        onSave={handleSaveMassive}
      />
    </Box>
  );
}